import React from "react";
import { Button, Card, CardBody, CardHeader, CardTitle, Table, Row, Col } from "reactstrap";
import { useNavigate } from "react-router-dom";
import PanelHeader from "components/panelheader/panelHeader";
import PaginationControls from "components/paginationcontrols/paginationControls";
import { usePageLoading } from "hooks/usePageLoading";
import { getSedes, deleteSede } from "services/sedesService";
import { getConfig } from "config/config";
import { toastBigError, toastConfirm } from "components/utils/toasts";
import { cleanString } from "components/utils/cleanString";
import { paginate } from "components/utils/paginate";
import _ from "lodash";

const Sedes = (props) => {
  const doneLoading = usePageLoading(props);
  const [allRecords, setAllRecords] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [sortColumn, setSortColumn] = React.useState({ path: "nombre", order: "asc" });
  const [searchQuery, setSearchQuery] = React.useState("");
  const config = getConfig();
  const pageSize = config.recordsPerPage;
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const records = await getSedes();
      if (records === "NETWORK ERROR") toastBigError("Error", "Error de Conexión");
      else setAllRecords(records);
    } catch {
    } finally {
      doneLoading();
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  const getPagedData = () => {
    let filtered = [];
    if (searchQuery.trim().length > 0) {
      filtered = allRecords.filter((m) => cleanString(m.descripcion).includes(cleanString(searchQuery)));
    } else {
      filtered = allRecords;
    }
    const ordered = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
    const records = paginate(ordered, currentPage, pageSize);
    return { totalCount: filtered.length, records };
  };

  const { totalCount, records } = getPagedData();
  if (currentPage > Math.ceil(totalCount / pageSize) && totalCount > 0) setCurrentPage(Math.ceil(totalCount / pageSize));

  const labelPages = Math.ceil(totalCount / pageSize) > 1 ? currentPage + "/" + Math.ceil(totalCount / pageSize) : "";

  const thead = [
    { header: "Nombre", width: "90%" },
    { header: "", width: "5%" },
    { header: "", width: "5%" },
  ];
  // const tbody = [
  //   {
  //     className: "table-success",
  //     data: ["Dakota Rice", "Niger", "Oud-Turnhout", "$36,738"],
  //   },
  //   {
  //     className: "",
  //     data: ["Minerva Hooper", "Curaçao", "Sinaai-Waas", "$23,789"],
  //   },
  //   {
  //     className: "table-info",
  //     data: ["Sage Rodriguez", "Netherlands", "Baileux", "$56,142"],
  //   },
  //   {
  //     className: "",
  //     data: ["Philip Chaney", "Korea, South", "Overland Park", "$38,735"],
  //   },
  //   {
  //     className: "table-danger",
  //     data: ["Doris Greene", "Malawi", "Feldkirchen in Kärnten", "$63,542"],
  //   },
  //   { className: "", data: ["Mason Porter", "Chile", "Gloucester", "$78,615"] },
  //   {
  //     className: "table-warning",
  //     data: ["Jon Porter", "Portugal", "Gloucester", "$98,615"],
  //   },
  // ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.currentTarget.value);
  };

  const handleNew = () => {
    navigate("/admin/sedes/nueva", {
      state: { action: "A" },
    });
  };

  const handleView = (id) => {
    navigate("/admin/sedes/" + id, {
      state: { action: "C" },
    });
  };

  const handleEdit = (id) => {
    // history.push({
    //   pathname: "/salas/" + id,
    //   state: { action: "E" },
    // });
    navigate("/admin/sedes/" + id, {
      state: { action: "E" },
    });
  };

  const handleDelete = async (id) => {
    // event.preventDefault();
    toastConfirm("¿ Eliminar sede ?", "Se eliminarán todas los torneos de esta sede", () => doDelete(id));
  };

  const doDelete = async (id) => {
    const originalRecords = allRecords;
    const records = allRecords.filter((m) => m._id !== id);
    setAllRecords(records);
    try {
      await deleteSede(id);
    } catch (ex) {
      if (ex.response && ex.response.status === 404) toastBigError("Ese registro ya fue eliminado");
      setAllRecords(originalRecords);
    }
  };

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col xs={12}>
            <Card>
              {/* <CardHeader>
                <CardTitle>
                  <Row className="align-items-center">
                    <Col>
                      <h4 className="pull-left" color="black">
                        <strong>Sedes</strong>
                      </h4>
                    </Col>
                    <Col>
                      <Button className="pull-right btn-arhock" onClick={() => handleNew()}>
                        Nueva Sede
                      </Button>
                    </Col>
                  </Row>
                </CardTitle>
              </CardHeader> */}
              <CardBody>
                <Row className="align-items-center">
                  {/* <Col>
                      <h4 className="pull-left" color="black">
                        <strong>Sedes</strong>
                      </h4>
                    </Col> */}
                  <Col>
                    <Button className="pull-right btn-arhock" onClick={() => handleNew()}>
                      Nueva Sede
                    </Button>
                  </Col>
                </Row>
                <Table responsive hover>
                  <thead className="text-black">
                    <tr>
                      {thead.map((prop, key) => {
                        if (key === thead.length - 2)
                          return (
                            <th key={key} className="text-left" style={prop.width ? { width: `${prop.width}` } : ""}>
                              {prop.header}
                            </th>
                          );
                        return (
                          <th key={key} color="black" style={prop.width ? { width: `${prop.width}` } : ""}>
                            {prop.header}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((item) => (
                      <tr key={Math.random()}>
                        <td className="clickable" onClick={() => handleView(item._id)}>
                          <span className="black">{item.nombre}</span>
                        </td>
                        <td>
                          <span className="clickable" onClick={() => handleEdit(item._id)}>
                            <div className="icon icon-success">
                              <i className="fa fa-pencil-square-o" color="success" />
                            </div>
                          </span>
                        </td>
                        <td>
                          <span className="clickable" onClick={() => handleDelete(item._id)}>
                            <div className="icon icon-danger">
                              <i className="fas fa-trash-alt" color="danger" />
                            </div>
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <Row className="pull-right">
                  <PaginationControls onPageChange={(page) => handlePageChange(page)} itemsCount={totalCount} pageSize={pageSize} currentPage={currentPage} />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Sedes;
